<template>
  <el-card>
    <!--    <i class="el-icon-refresh" @click="reload()" style="position: absolute;top: 10px;right: 20px;cursor: pointer;"></i>-->
    <SweetTable :is-page="false" ref="table" url="/erp/make/settle/report" :query-form="dataForm"
      :before-table-binding="beforeTableBinding" :summariesColumn="['sendCount', 'totalAmount']" :height="500"
      :row-style="rowStyleHandler">
      <el-table-column header-align="center" align="center" label="工厂名" prop="factoryName"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="product.code" label="品番号" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="product.skuCode" label="SKU" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="product.name" label="品名" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="product.color" label="颜色" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="product.size" label="规格" header-align="center" align="center"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="planCount" label="计划数" header-align="center" align="center"></el-table-column>
      <el-table-column prop="sendCount" label="工厂发货数" header-align="center" align="center"></el-table-column>
      <el-table-column prop="boxCount" label="箱单发货数" header-align="center" align="center"></el-table-column>
      <el-table-column prop="makePrice" label="加工费单价" header-align="center" align="center">
      </el-table-column>

      <el-table-column prop="checkPrice" label="包装检品费单价" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="packPrice" label="纸箱单价" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="cottonPrice" label="中棉" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="freightPrice" label="运费" header-align="center" align="center">
      </el-table-column>
      <el-table-column label="合计单价" header-align="center" align="center" prop="totalPrice">
      </el-table-column>
      <el-table-column label="收货单价" header-align="center" align="center" prop="realStorePrice">
      </el-table-column>
      <el-table-column label="金额" header-align="center" align="center" prop="totalAmount">
      </el-table-column>
      <el-table-column label="收货金额" header-align="center" align="center" prop="realStoreAmount">
      </el-table-column>
    </SweetTable>
  </el-card>
</template>

<script>
import MakeChargeService from '@/service/make/MakeChargeService'
import BigNumber from 'bignumber.js'
import SettleReportMixin from '@/views/modules/settle/report/SettleReportMixin'
export default {
  name: 'MakeReport',
  mixins: [SettleReportMixin],
  props: {
    orderId: ''
  },
  data() {
    return {
      dataForm: {
        orderId: ''
      },
      chargeReportList: []
    }
  },
  watch: {
    orderId: {
      handler: function (newVal) {
        if (!newVal) {
          this.$refs.table.dataList = []
          return
        }
        this.dataForm.orderId = newVal
        this.$nextTick(() => {
          this.loadData()
        })

      },
      immediate: true
    }
  },
  computed: {
    chargeColumns() {
      let tmp = []
      this.chargeReportList.forEach(cr => {
        if (cr.name.indexOf('中棉') > -1 || cr.name.indexOf('检品') > -1 || cr.name.indexOf('纸箱') > -1) {
          return
        }
        tmp.push(cr.name)
      })
      return tmp
    }
  },
  methods: {
    rowStyleHandler({ row }) {
      let rowStyle = {}
      if (row.sendCount !== row.boxCount) {
        rowStyle = {
          color: 'red'
        }
      }
      return rowStyle
    },
    async loadData() {
      this.chargeReportList = await MakeChargeService.queryReport(this.dataForm.parentId, this.dataForm.orderId)
      this.$refs.table.reload()
    },
    getRowOtherPrice(row, key) {
      if (!row.otherPrice) {
        return 0
      }
      let tmp = row.otherPrice.find(op => op.key === key)
      console.log('getRowOtherPrice', tmp)
      if (!tmp) {
        return 0
      }
      return tmp.value
    },
    getRowAmount(row) {
      row.totalAmount = new BigNumber(row.totalPrice).multipliedBy(row.sendCount).toFixed(2)
      row.totalPrice = new BigNumber(row.totalPrice).toFixed(5)
      console.log(row)
    },
    getTotalSendCount(dataList, factoryId) {
      let totalSendCount = new BigNumber(0)
      dataList.filter(item => item.factoryId === factoryId).forEach(row => {
        totalSendCount = totalSendCount.plus(row.sendCount)
      })
      return totalSendCount
    },
    beforeTableBinding(dataList) {
      this.chargeReportList.forEach(cr => {
        let totalSendCount = this.getTotalSendCount(dataList, cr.factoryId)
        cr.price = 0
        if (cr.amount === 0 || totalSendCount.comparedTo(0) === 0) {
          return
        }
        cr.price = new BigNumber(cr.amount).dividedBy(totalSendCount).toFixed(5)
      })
      dataList.forEach(row => {
        row.otherPrice = []
        this.chargeReportList.forEach(cr => {
          if (cr.name.indexOf('中棉') > -1 && row.cottonPrice === 0) {
            row.cottonPrice = cr.price
          } else if (cr.name.indexOf('检品') > -1 && row.checkPrice === 0) {
            row.checkPrice = cr.price
          } else if (cr.name.indexOf('纸箱') > -1 && row.packPrice === 0) {
            row.packPrice = cr.price
          } else {
            row.otherPrice.push({ key: cr.name, value: cr.price })
          }
        })
        try {
          this.getRowAmount(row)
        } catch (e) {
          console.log(e)
        }

      })
    },
  },
}
</script>

<style lang="scss" scoped>
.count-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 10px;
}
</style>
